import { RewardsProgramType } from '@shared/enums';
import { TFunction } from 'i18next';

export const programTypeLabel = (programType: RewardsProgramType, t: TFunction): string => (
  programType === RewardsProgramType.Energy
    ? t($ => $.pointsAudit.programs.energy)
    : t($ => $.pointsAudit.programs.agronomy)
);
